import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { useContext } from "react";
import { Controller } from "react-hook-form";
import FetchDataContext from "../context/fetchData/fetchDataContext";

const ReactHookFormSelect = ({
	name,
	label,
	control,
	defaultValue,
	children,
	error,
	value,
	state,
	setState,
	rules,
	handleChange,
	helperText,
	isForm,
	isService,
	...propss
}) => {
	const fetchData = useContext(FetchDataContext);
	const { stateOption, setStateOption } = fetchData;

	const labelId = `${name}-label`;
	const onChanges = (e) => {
		if (e.target.name === "idlayanan" && !isForm) {
			setStateOption({ ...stateOption, optionSLA: "" });
			setState({
				...state,
				idkategori: "",
				idgroup: "",
				deadline: "",
				iduser: "",
				[e.target.name]: e.target.value,
			});
			handleChange && handleChange(null);
		} else if (e.target.name === "idlayanan" && isService && !isForm) {
			setState({
				...state,
				idgroup: "0",
				[e.target.name]: e.target.value,
			});
			handleChange && handleChange(null);
		} else if (e.target.name === "idpriority" && !isForm) {
			setStateOption({ ...stateOption, optionSLA: "" });
			setState({
				...state,
				// idkategori: "", //tester FormControl
				idgroup: "",
				deadline: "",
				iduser: "",
				[e.target.name]: e.target.value,
			});
			handleChange && handleChange(null);
		} else if (
			e.target.name === "idgroup" ||
			e.target.name === "iduser" ||
			e.target.name === "time" ||
			e.target.name === "idpriority"
		) {
			setState({
				...state,
				idgroup: "",
				iduser: "",
				[e.target.name]: e.target.value,
			});
			handleChange && handleChange(null);
		} else {
			setState({ ...state, idkategori: "0", [e.target.name]: e.target.value });
			handleChange && handleChange(null);
		}
	};

	return (
		<FormControl {...propss} error={error}>
			<InputLabel id={labelId}>{label}</InputLabel>
			{setState && (
				<Controller
					name={name}
					control={control}
					rules={rules}
					defaultValue={value}
					render={({ props }) => (
						<>
							<Select
								MenuProps={{
									id: "id-menu",
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left",
									},
									getContentAnchorEl: null,
								}}
								error={error}
								labelId={labelId}
								label={label}
								value={value}
								name={name}
								onChange={onChanges}
								{...props}
							>
								{children}
							</Select>
							<FormHelperText id="component-helper-text">
								{error && error.message}
							</FormHelperText>
						</>
					)}
				/>
			)}
			{!setState && (
				<Controller
					name={name}
					control={control}
					rules={rules}
					defaultValue={value}
					render={({ props }) => (
						<>
							<Select
								MenuProps={{
									style: {
										maxHeight: 400,
										maxWidth: 300,
									},
									id: "id-menu",
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left",
									},
									getContentAnchorEl: null,
								}}
								error={error}
								labelId={labelId}
								label={label}
								value={value}
								name={name}
								{...props}
							>
								{children}
							</Select>
							<FormHelperText id="component-helper-text">
								{error && error.message}
							</FormHelperText>
						</>
					)}
				/>
			)}
		</FormControl>
	);
};
export default ReactHookFormSelect;
